import { useDebouncedValue }                 from "@mantine/hooks";
import { memo, useEffect, useRef, useState } from "react";

import { useGetLoggedIn }                   from "_common/hooks/auth";
import { useGetDarkMode, useSetLoginPopup } from "_common/hooks/global";
import { useSetOwnReactionsCount }          from "_common/hooks/stream";
import { useGetUpdateSession }              from "_jotai/liveSession";
import { sendBroadcastReactions }           from "_services/api/engagement";

import Presentation from "./presentation";

const component = ( { emotesList } ) => {
	const [ hoverState, setHoverState ] = useState ( false );
	const [ counter, setCounter ]       = useState ( 0 );
	const darkMode                      = useGetDarkMode ();
	const isLoggedIn                    = useGetLoggedIn ();
	const setLoginPopup                 = useSetLoginPopup ();
	const sessionData                   = useGetUpdateSession ();
	const setReactions                  = useSetOwnReactionsCount ();
	const broadcastSessionId            = sessionData?.id;

	const [ debounced ]                                         = useDebouncedValue ( counter, 50 );
	const [ enableInfiniteReaction, setEnableInfiniteReaction ] = useState ( {} );

	let reactionInfo = useRef ( null );

	let timerExit = useRef ( null );

	const handleHoverEnter = () => {
		clearTimeout ( timerExit.current );
		setHoverState ( true );
	};

	const handleHoverExit = () => {
		timerExit.current = setTimeout ( () => {
			setHoverState ( false );
		}, 200 );
	};

	useEffect ( () => {

		if ( !debounced || !broadcastSessionId ) {
			return;
		}
		const reactionCount = debounced;

		sendReactionsOnBroadcast ( broadcastSessionId, reactionCount, reactionInfo.current?.reactionId );
		setCounter ( 0 );
	}, [ debounced, broadcastSessionId ] );

	// calling api for broadcast heart reaction in chat
	const handleLikeAction = reaction => {
		if ( !isLoggedIn )
			return setLoginPopup ( true );
		setCounter ( counter + 1 );
		reactionInfo.current = reaction;
	};

	const showReactionsImmediately = ( { reactionCount, reactionId } ) => {
		setReactions ( prev => {
			if ( !prev[reactionId] ) {
				return {
					...prev,
					[reactionId]: {
						previousCount : reactionCount,
						showCount     : reactionCount
					}
				};
			}

			return {
				...prev,
				[reactionId]: {
					previousCount : prev[reactionId].previousCount + reactionCount,
					showCount     : reactionCount
				}
			};
		} );
	};

	const sendReactionsOnBroadcast = async ( broadcastSessionId, reactionCount, reactionId ) => {
		showReactionsImmediately ( { broadcastSessionId, reactionCount, reactionId } );

		try {
			if ( enableInfiniteReaction[reactionId] ) // do not make api calls further
				return;
			await sendBroadcastReactions ( { broadcastSessionId, reactionCount, reactionId } );

		} catch ( err ) {
			// backend starts giving 400s here
			setEnableInfiniteReaction ( prevState => ( { ...prevState, [reactionId]: true } ) );

			return;
		}
	};

	return (
		<Presentation
			darkMode            = { darkMode }
			emotesList          = { emotesList }
			handleLikeAction    = { handleLikeAction }
			hideReactionsSlider = { handleHoverExit }
			hoverState          = { hoverState }
			showReactionsSlider = { handleHoverEnter }

		/>
	);
};

export default memo ( component );
